import * as React from 'react'
import { useState } from 'react'
import { Button, Tooltip, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolderOpen } from '@fortawesome/pro-duotone-svg-icons/faFolderOpen'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import AppDialog from '@/Components/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { ArchivedMessageProps } from './types'

const ArchivedMessage: React.FC<ArchivedMessageProps> = ({
    kedo,
    messageId,
    getCheckedItems,
    updateMessage,
}) => {
    const [showModal, setShowModal] = useState<boolean>(false)
    const [isArchived, setIsArchived] = useState<boolean>(false)
    const url = kedo.api().getMessageEndpoint()

    const archiveMessageId = async () => {
        setIsArchived(true)
        try {
            await kedo.api().get(`${url}/${messageId}/archive`)
            setIsArchived(false)
            setShowModal(false)
            updateMessage()
        } catch (error) {
            setIsArchived(false)
            throw error
        }
    }

    const archivedMessage = async () => {
        if (messageId) return archiveMessageId()

        const checkedItems = getCheckedItems()
        let idsArchived = checkedItems.map((item) => item.id)
        if (!Array.isArray(idsArchived)) idsArchived = [idsArchived]

        setIsArchived(true)
        try {
            await Promise.all(
                idsArchived.map((id) => kedo.api().get(`${url}/${id}/archive`))
            )
            setIsArchived(false)
            setShowModal(false)
            updateMessage()
        } catch (error) {
            setIsArchived(false)
            throw error
        }
    }

    const warningMessage = () => setShowModal(true)

    return (
        <>
            <Tooltip title={kedo.t('Archive')} arrow>
                <StyledButton
                    color={messageId ? 'primary' : 'secondary'}
                    onClick={warningMessage}
                    startIcon={<FontAwesomeIcon icon={faFolderOpen} />}
                    sx={{
                        height: 38,
                        '& .MuiButton-startIcon': { ml: 0 },
                        ...(messageId && {
                            width: 40,
                            '& .MuiButton-startIcon': { margin: 0 },
                        }),
                        '& .MuiButton-startIcon svg': { fontSize: '16px' },
                    }}
                >
                    {!messageId && kedo.t('Archive')}
                </StyledButton>
            </Tooltip>

            <AppDialog
                open={showModal}
                onClose={() => setShowModal(false)}
                maxWidth="xs"
                fullWidth
                title={kedo.t('Confirm Archived')}
                actions={
                    <>
                        <Button
                            onClick={archivedMessage}
                            variant="contained"
                            color="error"
                            startIcon={
                                isArchived ? (
                                    <LoadingDefault size="sm" as="span" />
                                ) : (
                                    <FontAwesomeIcon icon={faFolderOpen} />
                                )
                            }
                            sx={{ textTransform: 'none' }}
                        >
                            {kedo.t('Archive')}
                        </Button>
                        <StyledButton
                            onClick={() => setShowModal(false)}
                            color="secondary"
                        >
                            {kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <Typography>
                    {kedo.t(
                        'Are you sure you want to archived these messages?'
                    )}
                </Typography>
            </AppDialog>
        </>
    )
}

export default ArchivedMessage
